export const COOKIES_USER_STORE_KEY = 'mnj_u';
export const COOKIES_SESSION_STORE_KEY = 'mnj_s';
